var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrize3 = function SvgPrize3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.915,
    height: 31.593
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prize-3_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554529"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 7831"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19253",
    d: "M491.66 508.9v26.307l12.958 5.286 12.958-5.286V508.9Z",
    transform: "translate(-491.659 -508.904)",
    fill: "url(#prize-3_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19254",
    d: "m12.844 28.341-.089-.038-9.9-4.189V3.178h19.98v20.933Zm-9.533-4.53 9.534 4.033 9.532-4.033V3.635H3.311Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19257",
    d: "M9.294 11.31a3.3 3.3 0 0 1 1.14-2.5 4.22 4.22 0 0 1 2.79-.882 4.553 4.553 0 0 1 2.022.412 2.968 2.968 0 0 1 1.27 1.116 3 3 0 0 1 .428 1.595 2.8 2.8 0 0 1-.526 1.723 2.576 2.576 0 0 1-1.254.946v.065a2.719 2.719 0 0 1 1.465 1.035 3.232 3.232 0 0 1 .526 1.909 3.363 3.363 0 0 1-.445 1.731 3.027 3.027 0 0 1-1.306 1.188 4.641 4.641 0 0 1-2.083.428 4.607 4.607 0 0 1-2.976-.922 3.448 3.448 0 0 1-1.213-2.717h2.2a1.762 1.762 0 0 0 .542 1.27 1.966 1.966 0 0 0 1.4.477 1.683 1.683 0 0 0 1.27-.461 1.641 1.641 0 0 0 .445-1.189 1.563 1.563 0 0 0-.615-1.391 3.429 3.429 0 0 0-1.91-.42h-.469v-1.858h.469q2.3 0 2.3-1.537a1.416 1.416 0 0 0-.412-1.084 1.671 1.671 0 0 0-1.189-.388 1.586 1.586 0 0 0-1.176.409 1.667 1.667 0 0 0-.477 1.043Z",
    fill: "#fff"
  }))));
};
export default SvgPrize3;